import { render } from "./Popups.vue?vue&type=template&id=7b244ff7&scoped=true&ts=true"
import script from "./Popups.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popups.vue?vue&type=script&setup=true&lang=ts"

import "./Popups.vue?vue&type=style&index=0&id=7b244ff7&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b244ff7"],['__file',"src/components/Popups.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b244ff7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b244ff7', __exports__)) {
    console.log('reload')
    api.reload('7b244ff7', __exports__)
  }
  
  module.hot.accept("./Popups.vue?vue&type=template&id=7b244ff7&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('7b244ff7', render)
  })

}


export default __exports__